import { render } from "./Menu.vue?vue&type=template&id=032c06e8&scoped=true&bindings={}"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=032c06e8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-032c06e8"

export default script